// extracted by css-extract-rspack-plugin
export default {"newThreadReplyDialog":"newThreadReplyDialog-uO1ZKN","toFieldSection":"toFieldSection-y5Aoww","fieldGroup":"fieldGroup-l78GkD"};